import { oneOf } from 'vee-validate/dist/rules';

const handler = {
  validate: (field, options) => oneOf.validate(field, options.values),
  params: ['values']
};

export { handler as oneOf };
